import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import icImageDefault from 'assets/images/ic-image-x.svg'
import icTrash from 'assets/images/ic-trash.svg'
import { Button } from 'avo-ui'
import { ACTION_TYPE } from 'constants/constant'
import { formatDateMoment } from 'utils/utils'

export const TABLE_PRODUCT_NOMINATION = {
    name: 'Product Nomination',
    column: [
        {
            name: 'Product Image',
            key: 'image_url',
            render: ({ item }) => (
                <img className={'w-7 h-7'} src={item?.image_url || icImageDefault} alt={item?.name} />
            ),
        },
        {
            name: 'Product Name',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <div className={'flex space-x-3'}>
                    <Button
                        type={'outline'}
                        title={'Edit'}
                        icon={icEditYellow}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.EDIT })}
                    />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        onClick={() => onClickItem({ item, actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}

export const INIT_STATE = {
    image_url: null,
    name: null,
}
